<div class="main-wrapper" >
	<div class="main-wrapper__icon">
		<i  [ngClass]="{'cp-icon-info': type==='info', 'cp-icon-status_confirm': type==='success',
		                'cp-icon-status_warning': type==='warning','cp-icon-error':type==='error'}">
		</i>
	</div>
   <div class="main-wrapper__message"><ng-content></ng-content></div>
</div>
